/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA 02110-1301, USA.
 *
 * Copyright (c) 2023-2024 (original work) Open Assessment Technologies SA;
 */

import { get, writable } from 'svelte/store';
import { fetchFeatureFlags } from '../services/configuration.service.js';

export const DEFAULT_FEATURE_FLAGS = {
    'DYNAMICRESULTLABELS': false,
    'SECUREBROWSERENABLED': false
};

const FEATURE_FLAG_KEYS = Object.keys(DEFAULT_FEATURE_FLAGS);

/**
 * Converts string boolean values to actual booleans
 * @param {*} value
 * @returns {boolean|*}
 */
export function parseFeatureFlagValue(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return value;
}

function createFeatureFlagsStore() {
    const featureFlags = writable(DEFAULT_FEATURE_FLAGS);
    const { set, update, subscribe } = featureFlags;

    return {
        get() {
            return get(featureFlags);
        },
        set,
        update,
        subscribe,

        async load() {
            try {
                const response = await fetchFeatureFlags(FEATURE_FLAG_KEYS);
                const data = await response.json();

                const parsedData = Object.fromEntries(
                    Object.entries(data).map(([key, value]) => [key, parseFeatureFlagValue(value)])
                );

                this.update(flags => ({
                    ...flags,
                    ...parsedData,
                }));
            } catch (err) {
                /* eslint-disable-next-line */
                console.warn(`Feature flags not available: ${err}`);
            }
        }
    };
}

export default createFeatureFlagsStore();
